import {
  firebaseConfiguration,
  Tenant,
  Environment,
} from './utils/configurations';
import { Config as MistSharedConfig } from '@crm-in-store/mist-shared-config';

const url = new URL(document.location.origin);
const searchURL = new URLSearchParams(window.location.search);
let env: Environment = 'dev';
let tenant: Tenant = 'th';
let isLocalhost = false;

if (url.host.indexOf('ck.') >= 0 || url.host.indexOf('calvinklein') >= 0) {
  tenant = 'ck';
}
// localhost tenant setup
if (url.host.indexOf('localhost') >= 0) {
  tenant = searchURL.get('theme')?.toLowerCase() === 'ck' ? 'ck' : 'th';
  isLocalhost = true;

  if (process.env.REACT_APP_OVERRIDE_VERSION) {
    // locally with command 'start:vX' we run against production environment
    // APIs.
    env = 'prd';
  }
}

switch (url.host) {
  case 'th.signup.stg.crm-in-store.eu.pvh.cloud':
  case 'th-v2.signup.stg.crm-in-store.eu.pvh.cloud':
  case 'ck.signup.stg.crm-in-store.eu.pvh.cloud':
    env = 'stg';
    break;
  case 'th.signup.prd.crm-in-store.eu.pvh.cloud':
  case 'th-v2.signup.prd.crm-in-store.eu.pvh.cloud':
  case 'ck.signup.prd.crm-in-store.eu.pvh.cloud':
  case 'signup.tommy.com':
  case 'signup.calvinklein.com':
    env = 'prd';
    break;
}

MistSharedConfig.set('env', env);
MistSharedConfig.set('tenant', tenant);

// Not a client secret, only a project identifier
const mixPanelProjectToken =
  env === 'prd' && !isLocalhost
    ? '1bb5d8c0bef5b2edb5cb18c620646509'
    : '20b2788c00974dec4f548a6a9f960023';

export const config = {
  env,
  api: {
    baseUrl: `https://api.${env}.crm-in-store.eu.pvh.cloud`,
  },
  firebaseConfiguration: firebaseConfiguration[tenant]![env],
  isLocalhost,
  tenant,
  mixPanelProjectToken,
};
